"use client";

import Script from "next/script";
import { useEffect } from "react";

const TWITTER_WIDGETS_SRC = "https://platform.twitter.com/widgets.js";

function loadTwitterWidgets() {
  if (typeof window === "undefined") return;
  window.twttr?.widgets?.load?.();
}

/**
 * Loads X/Twitter widgets.js and hydrates any .twitter-tweet blockquotes
 * left in WordPress post HTML (scripts in dangerouslySetInnerHTML do not run).
 */
export default function TwitterEmbedLoader() {
  useEffect(() => {
    loadTwitterWidgets();
  }, []);

  return (
    <Script
      src={TWITTER_WIDGETS_SRC}
      strategy="lazyOnload"
      onLoad={loadTwitterWidgets}
      onReady={loadTwitterWidgets}
    />
  );
}
